/* Zoeken binnen de collectie (was inline in sections/main-collection.liquid). Geladen met defer; de section-id komt uit data-section-id op [data-col-results]. */
(function () {
  function fmtMoney(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '€ ' + n.toFixed(2).replace('.', ',');
  }
  function thumb(src) {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_360x$1$3');
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initColSearch() {
    var field = document.querySelector('[data-col-search]');
    if (!field || field.dataset.bound) return;
    field.dataset.bound = '1';
    var input = field.querySelector('[data-col-search-input]');
    var clear = field.querySelector('[data-col-search-clear]');
    var count = field.querySelector('[data-col-search-count]');
    var resultsWrap = document.querySelector('[data-col-results]');
    var grid = resultsWrap && resultsWrap.querySelector('[data-col-results-grid]');
    var note = resultsWrap && resultsWrap.querySelector('[data-col-results-note]');
    var handle = field.getAttribute('data-col-handle');
    var root = field.getAttribute('data-col-root') || '';
    if (root === '/') root = ''; // deze store geeft '/' terug → anders wordt het '//collections' (kapotte fetch)
    var T = {
      none: field.getAttribute('data-t-noresults') || 'No products match your search.',
      one: field.getAttribute('data-t-result') || 'result',
      many: field.getAttribute('data-t-results') || 'results',
      sold: field.getAttribute('data-t-soldout') || 'Sold out'
    };

    var indexPromise = null;
    function loadIndex() {
      if (indexPromise) return indexPromise;
      // products.json only answers on the collection's original handle. In a translated storefront
      // the handle in the URL is translated ("analoge-cameras") and the list comes back empty, so
      // take the original from the x-default alternate link.
      var alt = document.querySelector('link[rel="alternate"][hreflang="x-default"]') || document.querySelector('link[rel="alternate"][hreflang="en"]');
      var altMatch = alt ? /\/collections\/([^\/?#]+)/.exec(alt.getAttribute('href') || '') : null;
      var base = root + '/collections/' + (altMatch ? altMatch[1] : handle) + '/products.json';
      indexPromise = (async function () {
        var all = [], page = 1;
        try {
          while (page <= 20) {
            var res = await fetch(base + '?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } });
            if (!res.ok) break;
            var data = await res.json();
            var prods = (data && data.products) || [];
            for (var k = 0; k < prods.length; k++) {
              var p = prods[k];
              var v = (p.variants && p.variants[0]) || {};
              var avail = (p.variants || []).some(function (x) { return x.available; });
              var img = (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
              all.push({
                id: String(p.id),
                k: all.length,
                t: ((p.title || '') + ' ' + (p.vendor || '') + ' ' + (p.product_type || '')).toLowerCase(),
                n: p.title || '',
                u: root + '/products/' + p.handle,
                i: thumb(img),
                p: fmtMoney(v.price),
                c: (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) ? fmtMoney(v.compare_at_price) : '',
                s: avail ? 0 : 1
              });
            }
            if (prods.length < 250) break;
            page++;
          }
        } catch (e) { /* val terug op geladen producten */ }
        return all;
      })();
      return indexPromise;
    }

    // Search results are shown as the theme's own product cards, in the normal grid, so they
    // look exactly like the collection page (badges, price in the visitor's currency, translated
    // title). The cards are taken from the collection's own pages via the Section Rendering API.
    var resultsEl = document.querySelector('[data-col-results]');
    var SECTION_ID = resultsEl ? resultsEl.getAttribute('data-section-id') : '';
    var PER_PAGE = 24;      // same as the paginate tag below
    var MAX_PAGES = 12;     // pages fetched for one query; matches beyond that get the simple card
    var cardCache = {}, pageCache = {};

    function originals() { return document.querySelectorAll('results-list .product-grid__item:not([data-col-search-item])'); }
    function gridList() { var item = originals()[0]; return item ? item.closest('ul') : null; }
    function clearSearchItems() { document.querySelectorAll('[data-col-search-item]').forEach(function (li) { li.remove(); }); }
    function remember(root) {
      root.querySelectorAll('li.product-grid__item[data-product-id]:not([data-col-search-item])').forEach(function (li) {
        var id = li.getAttribute('data-product-id');
        if (!cardCache[id]) cardCache[id] = li;
      });
    }
    function loadPage(n) {
      if (pageCache[n]) return pageCache[n];
      pageCache[n] = fetch(window.location.pathname + '?section_id=' + encodeURIComponent(SECTION_ID) + '&page=' + n)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { if (html) remember(new DOMParser().parseFromString(html, 'text/html')); })
        .catch(function () {});
      return pageCache[n];
    }
    function simpleCard(p) {
      var img = p.i ? '<img src="' + p.i + '" alt="' + esc(p.n) + '" loading="lazy">' : '';
      var sold = p.s ? '<span class="dt-col-result__sold">' + T.sold + '</span>' : '';
      var price = '<span class="dt-col-result__price">' + p.p + (p.c ? ' <s>' + p.c + '</s>' : '') + '</span>';
      return '<a class="dt-col-result" href="' + p.u + '"><span class="dt-col-result__img">' + img + sold + '</span><span class="dt-col-result__title">' + esc(p.n) + '</span>' + price + '</a>';
    }

    function showResults(on) {
      // tijdens zoeken: de gewone kaarten en de paginering verbergen
      // via een klasse en niet per kaart: kaarten die de pagina tijdens het zoeken bijlaadt
      // (oneindig scrollen) blijven dan ook verborgen
      var list = document.querySelector('results-list');
      if (list) list.classList.toggle('dt-col-searching', on);
      originals().forEach(function (li) { li.style.display = ''; });
      if (!on) clearSearchItems();
      document.querySelectorAll('results-list [class*="pagination"]').forEach(function (p) { p.style.display = on ? 'none' : ''; });
      if (resultsWrap) resultsWrap.classList.remove('is-visible');
    }

    async function render(matches, q) {
      var ul = gridList();
      clearSearchItems();
      if (grid) grid.innerHTML = '';
      if (matches.length === 0) {
        if (note) { note.textContent = T.none; note.hidden = false; }
        if (resultsWrap) resultsWrap.classList.add('is-visible');
        return;
      }
      if (note) note.hidden = true;
      if (!ul) {
        // geen gewone grid op de pagina: toon de eenvoudige kaarten in de eigen container
        if (grid) grid.innerHTML = matches.map(simpleCard).join('');
        if (resultsWrap) resultsWrap.classList.add('is-visible');
        return;
      }
      remember(document);
      var pages = [];
      matches.forEach(function (p) {
        var n = Math.floor(p.k / PER_PAGE) + 1;
        if (!cardCache[p.id] && pages.indexOf(n) === -1 && pages.length < MAX_PAGES) pages.push(n);
      });
      await Promise.all(pages.map(loadPage));
      if ((input.value || '').trim().toLowerCase() !== q) return; // query gewijzigd tijdens laden
      clearSearchItems();
      var frag = document.createDocumentFragment();
      matches.forEach(function (p) {
        var src = cardCache[p.id], li;
        if (src) {
          li = document.importNode(src, true);
          li.removeAttribute('id');
          li.removeAttribute('ref');
          li.style.display = '';
        } else {
          li = document.createElement('li');
          li.className = 'product-grid__item';
          li.innerHTML = simpleCard(p);
        }
        li.setAttribute('data-col-search-item', '');
        frag.appendChild(li);
      });
      ul.appendChild(frag);
    }

    function fallbackFilter(q) {
      // Terugval: filter de al geladen productkaarten in de grid
      showResults(false);
      var items = originals();
      var shown = 0;
      items.forEach(function (li) {
        var t = (li.getAttribute('data-title') || li.textContent || '').toLowerCase();
        var m = t.indexOf(q) !== -1;
        li.style.display = m ? '' : 'none';
        if (m) shown++;
      });
      if (count) count.textContent = shown + ' ' + (shown === 1 ? T.one : T.many);
    }

    function resetGrid() {
      originals().forEach(function (li) { li.style.display = ''; });
    }

    async function apply() {
      var q = (input.value || '').trim().toLowerCase();
      var active = q !== '';
      field.classList.toggle('is-active', active);
      if (!active) { showResults(false); resetGrid(); if (count) count.textContent = ''; return; }
      if (count) count.textContent = '…';
      var idx = [];
      try { idx = await loadIndex(); } catch (e) { idx = []; }
      if ((input.value || '').trim().toLowerCase() !== q) return; // query gewijzigd tijdens laden
      if (!idx || idx.length === 0) { fallbackFilter(q); return; } // index leeg → terugval op geladen producten
      var matches = idx.filter(function (p) { return p.t.indexOf(q) !== -1; });
      showResults(true);
      if (count) count.textContent = matches.length + ' ' + (matches.length === 1 ? T.one : T.many);
      render(matches, q);
    }

    input.addEventListener('focus', loadIndex, { once: true });
    input.addEventListener('input', apply);
    if (clear) clear.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initColSearch);
  } else {
    initColSearch();
  }
})();
